module.exports = __webpack_public_path__ + "static/media/einvoice-pending.3c83a2b1.svg";